import { icons } from 'common'
import styled, { css } from 'styled-components'
const designerCSS = css`
  .popUpContainer.user-account {
    min-width: 300px;
    max-width: 600px !important;
    width: 600px !important;
  }
  .popup:target .popUpContainer {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transition: top 0.5s ease;
    -moz-transition: top 0.5s ease;
    -o-transition: top 0.5s ease;
    transition: top 0.5s ease;
  }
  .popUpContainer.variable-width {
    width: fit-content;
    max-width: fit-content;
  }
  .popUpContainer {
    width: 100%;
    min-width: 300px;
    max-width: 600px;
    position: fixed;
    left: 50%;
    top: -100vh;
    -webkit-transition: top 0.5s ease;
    -moz-transition: top 0.5s ease;
    -o-transition: top 0.5s ease;
    transition: top 0.5s ease;
    transform: translateX(-50%);
    -webkit-box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
    -moz-box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
    box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
    border-radius: 10px;
    z-index: 99;
    background: var(--overlay-pad-background);
    backdrop-filter: blur(20px);
  }
`

const headerSection = css`
  .popUpContainer.user-account header {
    padding: 30px 30px 20px px 30px;
    width: 100%;
    justify-content: space-between;
    display: flex;
    align-items: center;
    border-bottom: 0;
  }

  .popUpContainer.user-account header {
    z-index: 1;
    position: relative;
    top: 0;
    font-size: 1.4rem;
    font-weight: 600;
    letter-spacing: -0.02em;
    padding: 30px;
    /* background: var(--overlay-pad-background);
    backdrop-filter: blur(20px); */
    border-radius: 10px 10px 0 0;
    line-height: 130%;
  }
  .popUpContainer.user-account .profile_wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .popUpContainer.user-account .profile_wrapper .profile_name {
    margin: 0 0 0 15px;
    font-weight: 600;
    font-size: 1.2rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .popUpContainer.user-account .profile_wrapper .profile_name span.email_address {
    font-size: 0.8rem;
    font-weight: 400;
    display: inline-flex;
    margin: 7px 0 0 0;
  }
  .user_signout {
    position: absolute;
    top: 30px;
    right: 30px;
    font-size: 0.8rem;
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.4);
    opacity: 0.7;
  }
  .user_signout:hover {
    cursor: pointer;
    border-bottom: 1px dotted transparent;
  }
`
const articleSection = css`
  .popUpContainer.user-account article {
    padding: 0;
    flex-wrap: wrap;
    flex-direction: column;
  }

  .popUpContainer.user-account article {
    max-height: 800px;
    height: fit-content;
    /* background: var(--overlay-pad-background);
    backdrop-filter: blur(20px); */
    border-radius: 0 0 10px 10px;
    display: flex;
    flex-direction: row;
  }
`
const tabs = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/global.css */
  * {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    font-family: 'Inter', sans-serif;
    padding: 0;
    margin: 0;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-synthesis: none;
    -moz-font-feature-settings: 'kern';
    shape-rendering: geometricPrecision;
    direction: ltr;
    line-height: 100%;
    font-weight: 400;
    color: #fff;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    transition: all 0.5s;
  }
  @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    *:hover ::-webkit-scrollbar {
      opacity: 1;
    }
    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track-piece {
      background-color: transparent;
      border-radius: 20px;
      opacity: 0;
    }
    ::-webkit-scrollbar-thumb {
      background-color: hsla(0, 0%, 100%, 0.5);
      border-radius: 20px;
    }
    ::-webkit-scrollbar-corner {
      background: rgba(0, 0, 0, 0);
    }
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/user-account.css */
  .user_tabs_wrapper {
    margin: 0 30px;
    width: 100%;
  }
  .user_tab {
    cursor: pointer;
    padding: 10px 15px 9px 15px;
    margin: 0;
    font-size: 0.75rem;
    text-align: center;
    display: flex;
    justify-content: center;
    text-transform: uppercase;

    border: 1px solid var(--tab-bar-border);
    background: var(--tab-bar-background);
    color: var(--tab-bar-color: );
  }
  .user_tabs_wrapper .user_tabs .user_tab:first-child {
    border-radius: 10px 0 0 10px;
  }

  .user_tabs_wrapper .user_tabs .user_tab:last-child {
    border-radius: 0 10px 10px 0;
    border-left: 0;
  }

  .user_tabs_wrapper .user_tabs .user_tab.active {
    font-weight: 600;
    background: var(--tab-bar-active-background);
    color: var(--tab-bar-active-color);
    border: 1px solid var(--tab-bar-active-border);
  }

  #user-overview_tab_one:checked ~ .user_tabs #user-overview_tab_one,
  #user-prefs_tab_two:checked ~ .user_tabs #user-prefs_tab_two,
  #user-api_tab_three:checked
    ~ .user_tabs
    #user-api_tab_three
    #user-api_tab_four:checked
    ~ .user_tabs
    #user-api_tab_four {
    font-weight: 600;
    background: var(--tab-bar-active-background);
    color: var(--tab-bar-active-color);
    border: 1px solid var(--tab-bar-active-border);
  }
  .user_tabs_wrapper .user_tabs {
    width: 100%;
    display: grid;
    grid-template-columns: ${({ gridColumns }) => gridColumns};
  }
  .user_tabs_wrapper input.radio {
    display: none;
  }
`

const footerSection = css`
  .content {
    height: calc(100% + 15px);
    height: 100%;
    transition: width 300ms ease-in-out;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    padding: 0 0 0 0;
    overflow: hidden;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/user-account.css */
  .popUpContainer.user-account .content {
    width: 100%;
    align-items: flex-start;
    border-top: 1px solid hsla(0, 0%, 100%, 0.1);
    padding: 30px 0 0 0;
    overflow: visible;
  }
  .popUpContainer.user-account .content.column {
    width: 100%;
    align-items: center;
    padding: 30px 0 0 0;
    border-top: 0;
  }
  .popUpContainer.user-account .content.column.action_area {
    border-top: 1px solid hsla(0, 0%, 100%, 0.1);
    border-radius: 0 0 10px 10px;
    margin: 15px 0 0 0;
    padding: 15px 30px 30px 30px;
    flex-direction: column;
    justify-content: center;
  }
  .popUpContainer.user-account button.edit_profile {
    height: fit-content;
    padding: 12px 20px 12px 40px;
    font-size: 0.8rem;
    position: relative;
    width: 100%;
    background: linear-gradient(0deg, #000000, #030303, #050505, #080808, #0b0b0b, #0d0d0d, #0f0f0f, #111111);
  }
  .popUpContainer.user-account button.edit_profile:hover {
    background: linear-gradient(0deg, #111111, #111111, #111111, #111111, #111111, #111111, #111111, #111111);
  }
  .popUpContainer.user-account button.edit_profile:before {
    background: url(${icons.edit_icon}) center center / auto 14px no-repeat;
    width: 20px;
    height: 20px;
    position: absolute;
    content: '';
    top: 50%;
    left: calc(50% - 50px);
    transform: translate(-50%, -50%);
  }
`
const developerCSS = css`
  .popUpContainer {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  div.closePopUp {
    top: -5px;
    left: -5px;
    mask: url(${icons.close_window_icon}) center center / 22px auto no-repeat;
    background: hsl(0, 0%, 100%);
    width: 22px;
    height: 22px;
    display: block;
    position: absolute;
    z-index: 1;
    &:hover {
      cursor: pointer;
    }
  }
  .info_asset_icon {
    background: var(--input-background) url(${icons.info_icon}) center center / auto 10px no-repeat;
    padding: 10px;
    margin: 0 5px 0 0;
    border-radius: 6px;
    display: flex;
    width: fit-content;
    height: fit-content;
  }

  .edit_username {
    width: 100%;
    background: var(--input-background);
    border-radius: 10px;
    font-size: 0.8rem;
    text-align: left;
    padding: 10px;
    border: none;
    outline: none;
  }
  .save_profile {
    height: fit-content;
    padding: 12px 20px;
    font-size: 0.8rem;
    position: relative;
    margin: 0 0 5px 0;
    width: 100%;
    border-radius: 10px;
    background: linear-gradient(
      180deg,
      #2159d1,
      #2159d0,
      #2158cf,
      #2057cd,
      #2056ca,
      #1f55c7,
      #1f53c3,
      #1e52c0,
      #1e51bd,
      #1d50bb,
      #1d4fba,
      #1d4fb9
    );
  }
  .cancel_profile {
    height: fit-content;
    padding: 12px 20px;
    font-size: 0.8rem;
    position: relative;
    border-radius: 10px;
    background: var(--toggle-background);
    width: 100%;
    &:hover {
      background: var(--toggle-background);
    }
  }
`

export const OrderUpdateModalCss = styled.div`
  ${designerCSS}
  ${headerSection}
  ${articleSection}
  ${tabs}
  ${footerSection}
  ${developerCSS}
`
